<template>
  <div>
    <div class="approval-container">
      <div class="title">审批流程</div>
      <div class="approval-body">
        <div v-for="(flowNode,index) in flowData" :key="index" class="approval-body-item-wrap">
          <div class="approval-body-item">
            <div class="left-icon"></div>
            <div class="right-content">
              <div class="node-title">
                <div class="node-left">发起审批</div>
                <div class="middle"></div>
                <div class="node-right">提交</div>
                <i :class="flowNode.openOrPutawayType ? 'el-icon-arrow-up':'el-icon-arrow-down'" @click="openOrPutaway(flowNode)"></i>
              </div>
              <div class="node-body" v-show="flowNode.openOrPutawayType">
                <div class="node-item">
                  <div class="node-person">
                    <div class="person-name">{{flowNode.submitter}}</div>
                    <div class="person-right">
                      <div class="reject-and-time">
                        <div class="time">{{flowNode.submitTime|getTime}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="approval-body-item"
            v-for="(checkNode,index) in flowNode.checkNodes"
            :key="index"
          >
            <div class="left-icon"></div>
            <div class="right-content">
              <div class="node-title">
                <div
                  class="node-left"
                >{{ '('+ CHECK_TYPE[checkNode.checkType] + ')' + checkNode.name}}</div>
                <div class="middle"></div>
                <div
                  :class="checkNode.checkState==2?'node-right-reject':'node-right'"
                >{{CHECK_STATE[checkNode.checkState]}}</div>
                <i :class="checkNode.openOrPutawayType ? 'el-icon-arrow-up':'el-icon-arrow-down'" @click="openOrPutaway(checkNode)"></i>
              </div>
              <div class="node-body" v-show="checkNode.openOrPutawayType">
                <div class="node-item" v-for="(task,index) in checkNode.tasks" :key="index">
                  <div class="node-person">
                    <div class="person-name">{{task.checkerName}}</div>
                    <div class="person-right">
                      <div class="reject-and-time">
                        <div
                          :class="[{reject:task.checkState === 2},{adopt:task.checkState === 1},{adopt:task.checkState === 0}]"
                        >{{CHECK_STATE[task.checkState]}}</div>
                        <div class="middle" v-if="task.checkTime"></div>
                        <div class="time" v-if="task.checkTime">{{task.checkTime|getTime}}</div>
                      </div>

                      <div class="type">{{task.autoCompleteType |setautoCompleteType }}</div>
                    </div>
                  </div>
                  <div class="opinion" v-if="task.comment">审批意见：{{task.comment}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CHECK_STATE, CHECK_TYPE } from "./const";
let moment = require("moment");
moment.locale("zh-cn");
export default {
  components: {
  },
  props: ["flowData"],
  data() {
    return {
      CHECK_STATE,
      CHECK_TYPE
    };
  },
  filters: {
    getTime(val) {
      return moment(val).format("MM/DD HH:mm");
    },
    setautoCompleteType(val) {
      if (val === 1) {
        return "审批人重复，自动通过";
      } else if (val === 2) {
        return "异常处理，自动通过";
      } else {
        return;
      }
    }
  },
  methods: {
    openOrPutaway(flowNode) {
      flowNode.openOrPutawayType = !flowNode.openOrPutawayType;
    }
  }
};
</script>
<style lang="less" scoped>
.approval-container {
  // width: 343px;
  background: #ffffff;
  box-shadow: 0rem 3px 3px 0rem rgba(227, 235, 255, 0.3);
  border-radius: 10px;
  border: 1px solid #e7f1fe;
  margin: 0 auto;
  padding: 16px 18px;
  box-sizing: border-box;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4a5462;
    line-height: 20px;
    margin-bottom: 13px;
  }
  .approval-body {
    .approval-body-item-wrap {
      .approval-body-item {
        margin-top: 20px;
        position: relative;
        margin-left: 10px;
        .left-icon {
          width: 16px;
          height: 16px;
          border: 4px solid #428ff8;
          border-radius: 50%;
          box-sizing: border-box;
          background-color: #fff;
          position: absolute;
          left: -7.5px;
        }
        .right-content {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #020912;
          line-height: 20px;
          padding-left: 26px;
          border-left: 1px dashed #74879b;
          padding-bottom: 15px;
          .node-title {
            display: flex;
            align-items: center;
            .node-left {
              max-width: 190px;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
            }
            .node-right {
              color: #4a5462;
            }
            .node-right-reject {
              color: #fa9c2b;
            }
            .el-icon-arrow-up,
            .el-icon-arrow-down {
                margin-left: 10px;
            }
          }
          .node-body {
            .node-item {
              margin-top: 15px;
              .node-person {
                padding-left: 17.5px;
                width: 225px;
                display: flex;
                justify-content: space-between;

                .person-name {
                  width: 90px;
                }
                .person-right {
                  display: flex;
                  flex-direction: column;

                  .reject-and-time {
                    display: flex;
                    align-items: center;
                    .reject {
                      color: #fa9c2b;
                    }
                    .adopt {
                      color: #4a5462;
                    }
                    .await {
                      color: #00cca2;
                    }
                  }
                  .type {
                    font-size: 12px;
                    color: #74879b;
                  }
                }
              }
              .opinion {
                width: 225px;
                padding-left: 17.5px;
                font-size: 12px;
                color: #74879b;
                margin-top: 5px;
              }
            }
          }
        }
      }
      &:last-child {
        .approval-body-item {
          &:last-child {
            .right-content {
              border-left: none;
            }
          }
        }
      }
    }
  }
}
.middle {
  width: 4px;
  height: 4px;
  background: #a9b6c4;
  border-radius: 50%;
  margin: 0 4.5px 0 3.5px;
}
</style>